import { render, staticRenderFns } from "./BarrelDetails.vue?vue&type=template&id=25a8f5b4&"
import script from "./BarrelDetails.vue?vue&type=script&lang=ts&"
export * from "./BarrelDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports